import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import ar from './locales/ar.json';

const saved = localStorage.getItem('locale');
const defaultLocale = (saved && ['en','ar'].includes(saved)) ? saved : 'ar';

const i18n = createI18n({
  legacy: false,
  locale: defaultLocale,
  fallbackLocale: 'en',
  messages: { en, ar },
});

export default i18n;